import { Spinner } from '@air/primitive-spinner';

import { InfiniteScrollContainer } from '~/components/InfiniteScroll/InfiniteScrollContainer';

type InfiniteScrollSpinnerProps = {
  dataTestId?: string;
};

export const InfiniteScrollSpinner = ({ dataTestId }: InfiniteScrollSpinnerProps) => {
  return (
    <InfiniteScrollContainer>
      <Spinner className="size-7 ads:text-ads-cyan-10 text-teal-9" data-testid={dataTestId} />
    </InfiniteScrollContainer>
  );
};
